export const LEGAL_PAGES = {
  'privacy-policy': {
    title: 'Privacy Policy',
    intro:
      'Welcome to CapableBee. Our Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website and use our services. By using our website and services, you agree to the terms outlined in this policy.',
    effective: 'Effective Date: 17/01/2025',
    sections: [
      {
        h: '1. Information We Collect',
        blocks: [
          { t: 'p', c: 'We may collect the following types of information when you use our website or services.' },
          { t: 'h4', c: 'Personal Information' },
          { t: 'ul', c: ['Name', 'Email address', 'Phone number', 'Company name', 'Any information you provide through forms or communications with us'] },
          { t: 'h4', c: 'Usage Information' },
          { t: 'p', c: 'We may automatically collect certain information about your interaction with our website, including:' },
          { t: 'ul', c: ['IP address', 'Browser type', 'Device information', 'Pages visited', 'Time spent on pages', 'Referring website'] },
        ],
      },
      {
        h: '2. How We Use Your Information',
        blocks: [
          { t: 'p', c: 'We use the information we collect to:' },
          { t: 'ul', c: ['Provide and operate our services', 'Respond to inquiries and support requests', 'Improve our website and services', 'Send important updates or service notifications', 'Analyze usage trends to enhance user experience', 'Ensure security and prevent fraud'] },
        ],
      },
      {
        h: '3. Google API and Calendar Data Usage',
        blocks: [
          { t: 'p', c: 'CapableBee may integrate with Google APIs, including Google Calendar, to provide scheduling and automation features.' },
          { t: 'p', c: 'With your explicit consent, we may:' },
          { t: 'ul', c: ['Read calendar events', 'Create, update, or delete events'] },
          { t: 'p', c: 'This access is used strictly to provide core functionality such as appointment scheduling, workflow automation, and user-requested actions.' },
          { t: 'p', c: 'Google user data is accessed only when necessary to provide user-requested functionality.' },
          { t: 'p', c: 'We do not allow humans to read this data unless required for support, troubleshooting, or with explicit user consent.' },
          { t: 'b', c: 'We do not use Google user data for advertising or marketing purposes.' },
        ],
      },
      {
        h: '4. Google API Services User Data Policy Compliance',
        blocks: [
          { t: 'p', c: "CapableBee's use and transfer of information received from Google APIs to any other app will adhere to the Google API Services User Data Policy, including the Limited Use requirements." },
          { t: 'ul', c: ['Limited Use: Our app only uses Google user data to provide or improve user-facing features that are prominent in the user interface.', 'No Training on Data: We do not use Google user data to train, retrain, or improve generalized AI or Machine Learning models.', "Transfer Restrictions: We do not transfer Google user data to third parties unless it is necessary to provide or improve the app's features, to comply with applicable law, or as part of a merger/acquisition.", 'Human Review: We do not allow humans to read Google user data unless we have your affirmative agreement for specific messages, it is necessary for security purposes (such as investigating abuse), it is required to comply with applicable law, or for the app\'s internal operations (and even then, only when the data has been aggregated and anonymized).'] },
        ],
      },
      {
        h: '5. AI Voice and Call Processing',
        blocks: [
          { t: 'p', c: 'CapableBee provides AI-powered voice assistant services that may process phone calls and conversations.' },
          { t: 'p', c: 'By using our services, you acknowledge that:' },
          { t: 'ul', c: ['Calls handled by AI assistants may be recorded or transcribed', 'Information shared during calls may be stored for service functionality, analytics, and improvement'] },
          { t: 'p', c: 'We process this data in accordance with applicable laws and industry standards.' },
        ],
      },
      {
        h: '6. Sharing of Information',
        blocks: [
          { t: 'p', c: 'We do not sell your personal information.' },
          { t: 'p', c: 'We may share data with third-party service providers strictly to operate our services, such as:' },
          { t: 'ul', c: ['Cloud infrastructure providers (for hosting and storage)', 'Communication providers (for handling calls and messages)', 'Analytics tools (to improve performance and user experience)'] },
          { t: 'p', c: 'These providers only process data on our behalf and are contractually obligated to protect it.' },
        ],
      },
      {
        h: '7. Data Security',
        blocks: [
          { t: 'p', c: 'We implement reasonable technical and organizational security measures to protect your information from unauthorized access, disclosure, alteration, or destruction.' },
          { t: 'p', c: 'However, no system can guarantee absolute security.' },
        ],
      },
      {
        h: '8. Cookies and Tracking Technologies',
        blocks: [
          { t: 'p', c: 'Our website may use cookies and similar technologies to improve functionality and analyze website usage.' },
          { t: 'p', c: 'Cookies help us:' },
          { t: 'ul', c: ['Understand how visitors use our website', 'Improve performance and user experience', 'Provide relevant features and services'] },
          { t: 'p', c: 'You can modify your browser settings to refuse cookies if you prefer.' },
        ],
      },
      {
        h: '9. Data Retention',
        blocks: [
          { t: 'p', c: 'We retain your information only for as long as necessary to:' },
          { t: 'ul', c: ['Provide our services', 'Comply with legal obligations', 'Resolve disputes', 'Enforce agreements'] },
          { t: 'p', c: 'Google user data is retained only as long as necessary to provide the requested functionality.' },
        ],
      },
      {
        h: '10. Your Rights',
        blocks: [
          { t: 'p', c: 'Depending on your location, you may have the right to:' },
          { t: 'ul', c: ['Access the personal data we hold about you', 'Request correction of inaccurate information', 'Request deletion of your data', 'Withdraw consent where applicable'] },
          { t: 'p', c: 'To request deletion of your data, including any data obtained via Google APIs, please contact us at: support@capablebee.com.' },
          { t: 'p', c: 'We will process such requests within a reasonable timeframe.' },
        ],
      },
      {
        h: '11. Third-Party Services',
        blocks: [
          { t: 'p', c: 'Our services may integrate with third-party platforms or services. We are not responsible for the privacy practices of those third parties.' },
          { t: 'p', c: 'We encourage you to review their privacy policies separately.' },
        ],
      },
      {
        h: '12. Changes to This Policy',
        blocks: [
          { t: 'p', c: 'We may update this Privacy Policy from time to time. Updates will be posted on this page with a revised effective date.' },
          { t: 'p', c: 'Your continued use of our website and services after changes indicates acceptance of the updated policy.' },
        ],
      },
      {
        h: '13. Data Deletion and Google User Data',
        blocks: [
          { t: 'p', c: 'Users can request deletion of their data at any time by contacting support@capablebee.com.' },
          { t: 'p', c: 'Upon request:' },
          { t: 'ul', c: ['All personal data will be deleted from our systems', 'Any stored Google user data will be removed', 'Access tokens will be revoked'] },
          { t: 'p', c: 'We retain Google user data only as long as necessary to provide the requested functionality.' },
        ],
      },
      {
        h: '14. Contact Us',
        blocks: [
          { t: 'p', c: 'If you have any questions regarding this Privacy Policy or our data practices, please contact us:' },
          { t: 'contact' },
        ],
      },
    ],
  },

  'terms-of-service': {
    title: 'Terms and Conditions',
    intro:
      'Welcome to CapableBee. These Terms and Conditions govern your use of our website and services. By accessing or using CapableBee, you agree to comply with these terms.',
    intro2: 'If you do not agree with any part of these terms, you should not use our website or services.',
    effective: 'Effective Date: 17/01/2025',
    sections: [
      {
        h: '1. Use of Services',
        blocks: [
          { t: 'p', c: 'CapableBee provides AI-powered voice assistant and automation services designed to help businesses manage conversations, capture leads, and automate communication.' },
          { t: 'p', c: 'By using our services, you agree to:' },
          { t: 'ul', c: ['Use the services only for lawful purposes', 'Provide accurate information when required', 'Not misuse or interfere with the functionality of the platform', 'Comply with all applicable laws and regulations'] },
        ],
      },
      {
        h: '2. User Responsibilities',
        blocks: [
          { t: 'p', c: 'You are responsible for:' },
          { t: 'ul', c: ['Maintaining the confidentiality of your account credentials', 'Ensuring that any information you provide is accurate and up to date', 'Any activities conducted through your account'] },
          { t: 'p', c: 'CapableBee is not responsible for unauthorized access caused by your failure to secure your login credentials.' },
        ],
      },
      {
        h: '3. AI Voice and Communication Services',
        blocks: [
          { t: 'p', c: 'CapableBee offers AI voice assistants that interact with customers through phone calls or other communication channels.' },
          { t: 'p', c: 'By using these services, you acknowledge that:' },
          { t: 'ul', c: ['AI-generated conversations may be recorded or transcribed', 'You are responsible for ensuring compliance with local telecommunication laws', 'You must inform callers if required by law that they may be interacting with an AI system'] },
        ],
      },
      {
        h: '4. Prohibited Use',
        blocks: [
          { t: 'p', c: 'You agree not to use CapableBee services for:' },
          { t: 'ul', c: ['Illegal activities', 'Fraudulent or deceptive practices', 'Harassment, spam, or abusive communications', 'Violating telecommunications or privacy laws'] },
          { t: 'p', c: 'CapableBee reserves the right to terminate accounts that violate these rules.' },
        ],
      },
      {
        h: '5. Intellectual Property',
        blocks: [
          { t: 'p', c: 'All content on this website, including logos, designs, text, software, and graphics, is the property of CapableBee or its licensors.' },
          { t: 'p', c: 'You may not copy, reproduce, distribute, or modify any part of the website without prior written permission.' },
        ],
      },
      {
        h: '6. Service Availability',
        blocks: [
          { t: 'p', c: 'We aim to provide reliable services but do not guarantee uninterrupted or error-free operation.' },
          { t: 'p', c: 'CapableBee may update, modify, or temporarily suspend services for maintenance or improvements.' },
        ],
      },
      {
        h: '7. Limitation of Liability',
        blocks: [
          { t: 'p', c: 'To the maximum extent permitted by law, CapableBee shall not be liable for:' },
          { t: 'ul', c: ['Any indirect or consequential damages', 'Loss of profits, revenue, or data', 'Service interruptions beyond our control'] },
          { t: 'p', c: 'Your use of our services is at your own risk.' },
        ],
      },
      {
        h: '8. Third-Party Services',
        blocks: [
          { t: 'p', c: 'CapableBee may integrate with third-party platforms and services such as communication providers, analytics tools, and APIs including Google services.' },
          { t: 'p', c: 'By using such integrations, you acknowledge that your data may be processed by these third-party services in accordance with their respective privacy policies.' },
          { t: 'p', c: 'CapableBee is not responsible for the performance, availability, or policies of third-party services.' },
        ],
      },
      {
        h: '9. Termination',
        blocks: [
          { t: 'p', c: 'We reserve the right to suspend or terminate access to our services if users violate these Terms and Conditions or engage in harmful activities.' },
          { t: 'p', c: 'Users may also discontinue using the service at any time.' },
        ],
      },
      {
        h: '10. Changes to Terms',
        blocks: [
          { t: 'p', c: 'CapableBee may update these Terms and Conditions from time to time. Updates will be posted on this page with a revised effective date.' },
          { t: 'p', c: 'Continued use of the website or services after changes means you accept the updated terms.' },
        ],
      },
      {
        h: '11. Governing Law',
        blocks: [
          { t: 'p', c: 'These Terms and Conditions shall be governed by and interpreted in accordance with the laws of India.' },
          { t: 'p', c: 'Any disputes arising from these terms shall be subject to the jurisdiction of the appropriate courts in India.' },
        ],
      },
      {
        h: '12. Data and Privacy',
        blocks: [
          { t: 'p', c: 'Your use of CapableBee is subject to our Privacy Policy.' },
          { t: 'p', c: 'By using our services, you consent to the collection and use of information, including data obtained through third-party integrations such as Google APIs, as described in our Privacy Policy.' },
          { t: 'p', c: 'We are committed to protecting user data and ensuring compliance with applicable data protection laws and platform policies.' },
        ],
      },
      {
        h: '13. Google API Services',
        blocks: [
          { t: 'p', c: 'CapableBee may integrate with Google APIs, including Google Calendar, to provide scheduling and automation features.' },
          { t: 'p', c: 'By using these features, you authorize CapableBee to access and process your Google data as required to deliver the service.' },
          { t: 'p', c: "CapableBee's use of information received from Google APIs will comply with the Google API Services User Data Policy, including the Limited Use requirements." },
        ],
      },
      {
        h: '14. Contact Information',
        blocks: [
          { t: 'p', c: 'If you have any questions regarding these Terms and Conditions, please contact us:' },
          { t: 'contact' },
        ],
      },
    ],
  },

  'refund-policy': {
    title: 'Refund Policy',
    intro: 'This Refund Policy outlines the terms regarding refunds for services provided by CapableBee.',
    effective: 'Effective Date: 17/01/2025',
    sections: [
      {
        h: '1. Service Nature',
        blocks: [
          { t: 'p', c: 'CapableBee provides digital services including AI voice assistants, automation tools, and related solutions. Due to the nature of digital and software-based services, refunds may not always be possible once services have been activated or used.' },
        ],
      },
      {
        h: '2. Refund Eligibility',
        blocks: [
          { t: 'p', c: 'Refund requests may be considered under the following circumstances:' },
          { t: 'ul', c: ['Duplicate payment', 'Technical issues preventing service use that cannot be resolved', 'Billing errors'] },
          { t: 'b', c: 'Refund requests must be submitted within 7 days of purchase.' },
        ],
      },
      {
        h: '3. Non-Refundable Situations',
        blocks: [
          { t: 'p', c: 'Refunds will generally not be provided in the following cases:' },
          { t: 'ul', c: ['Change of mind after purchase', 'Partial usage of services', 'Failure to use the service after activation', 'Violations of our Terms and Conditions'] },
        ],
      },
      {
        h: '4. Refund Processing',
        blocks: [
          { t: 'p', c: 'If a refund request is approved:' },
          { t: 'ul', c: ['The refund will be processed using the original payment method', 'Processing times may vary depending on the payment provider', 'It may take 5–10 business days for the refund to appear in your account'] },
        ],
      },
      {
        h: '5. Subscription Services',
        blocks: [
          { t: 'p', c: 'For subscription-based services:' },
          { t: 'ul', c: ['You may cancel your subscription at any time', 'Cancellation will stop future billing', 'Payments already processed are generally non-refundable unless required by law'] },
        ],
      },
      {
        h: '6. Contact Us',
        blocks: [
          { t: 'p', c: 'If you would like to request a refund or have questions about this policy, please contact us:' },
          { t: 'contact' },
        ],
      },
    ],
  },

  'cookie-policy': {
    title: 'Cookie Policy',
    intro:
      'This Cookie Policy explains how CapableBee uses cookies and similar technologies when you visit our website. By continuing to browse our website, you agree to our use of cookies as described in this policy.',
    effective: 'Effective Date: 17/01/2025',
    sections: [
      {
        h: '1. What Are Cookies',
        blocks: [
          { t: 'p', c: 'Cookies are small text files stored on your device when you visit a website. They help websites function properly, improve user experience, and provide information to website owners.' },
          { t: 'p', c: 'Cookies may collect information such as browser type, device information, pages visited, and user preferences.' },
        ],
      },
      {
        h: '2. How We Use Cookies',
        blocks: [
          { t: 'p', c: 'CapableBee uses cookies to:' },
          { t: 'ul', c: ['Ensure the website functions properly', 'Improve website performance and usability', 'Analyze website traffic and visitor behavior', 'Remember user preferences', 'Provide better services and features'] },
        ],
      },
      {
        h: '3. Types of Cookies We Use',
        blocks: [
          { t: 'h4', c: 'Essential Cookies' },
          { t: 'p', c: 'These cookies are necessary for the website to operate properly. Without them, certain features of the site may not function.' },
          { t: 'h4', c: 'Performance Cookies' },
          { t: 'p', c: 'These cookies collect information about how visitors use our website, helping us improve functionality and user experience.' },
          { t: 'h4', c: 'Analytics Cookies' },
          { t: 'p', c: 'We may use analytics tools that collect anonymous data about website usage, such as pages visited and session duration.' },
        ],
      },
      {
        h: '4. Third-Party Cookies',
        blocks: [
          { t: 'p', c: 'Some cookies may be placed by third-party services we use, such as analytics providers or embedded tools. These third parties may collect information according to their own privacy policies.' },
        ],
      },
      {
        h: '5. Managing Cookies',
        blocks: [
          { t: 'p', c: 'You can control or disable cookies through your browser settings.' },
          { t: 'p', c: 'Most browsers allow you to:' },
          { t: 'ul', c: ['Block cookies', 'Delete existing cookies', 'Receive alerts when cookies are used'] },
          { t: 'p', c: 'Please note that disabling cookies may affect the functionality of some parts of our website.' },
        ],
      },
      {
        h: '6. Changes to This Cookie Policy',
        blocks: [
          { t: 'p', c: 'We may update this Cookie Policy from time to time. Any changes will be posted on this page with an updated effective date.' },
        ],
      },
      {
        h: '7. Contact Us',
        blocks: [{ t: 'p', c: 'If you have any questions about this Cookie Policy, please contact us:' }, { t: 'contact' }],
      },
    ],
  },
};

export const slugify = (h) =>
  h.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
